import apiHandler from "../core/apiHandler";

const allowedOptionsApi = apiHandler("settings/allowed-options");

export default allowedOptionsApi;
